import { z } from 'zod';
import {
  MICE_EVENT_RULES,
  MiceEventRuleSchema,
  MicePremisesKeySchema,
} from '@voll-intelligence/domain';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * `event_premises` — linha compacta da ficha de premissas do evento (grupos e
 * eventos). O agente a emite a cada turno; o web-chat abre/atualiza a folha de
 * premissas a partir dela. `missing` lista as premissas ainda sem valor.
 */
export const EventPremisesBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('event_premises'),
    eventId: z.string().min(1).max(64),
    name: z.string().min(1).max(120),
    eventStart: z.iso.date(),
    eventEnd: z.iso.date(),
    confirmed: z.boolean(),
    missing: z.array(MicePremisesKeySchema).max(20),
    // Regras de viagem ainda sem valor; ausente em agente antigo (vale `missing`).
    pending: z.array(MiceEventRuleSchema).max(MICE_EVENT_RULES.length).optional(),
  })
  .strict();
export type EventPremisesBlock = z.infer<typeof EventPremisesBlockSchema>;
